import React from 'react';

const NavButton = (props) => {

    return (
        <div className="button" onClick={props.setPage}>{props.children}</div>
    );
}

export default NavButton;